import React, { useContext, useEffect, useState } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import { ProductContext } from "../App";
import Edit from "../components/popups/Edit";
import ShowImage from "../components/ShowImage";
import RoleComponent from "../components/authentications/RoleComponent";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import CloseIcon from "@mui/icons-material/Close";

function StockTable() {
  const product_context = useContext(ProductContext);
  const {
    confirmDialogue,
    setConfirmDialogue,
    setSoldDataSearchById,
    setIsLoading,
    setOrderTableCategory,
    alert,
    setAlert,
  } = product_context;
  const [products, setProducts] = useState([]);
  const [searchTerm, setSearchTerm] = useState("Shoes");
  const [productSearch, setProductSearch] = useState("");
  const [listActive, setListActive] = useState(false);
  const [sizeInp, setSizeInp] = useState([""]);
  const [input, setInput] = useState("");
  const [showImage, setShowImage] = useState({
    isOpen: false,
    product: {},
  });
  const [editParams, setEditParams] = useState({
    isOpen: false,
    data: {},
    setSizeInp,
  });
  const navigate = useNavigate();
  const [overallTotal, setOverallTotal] = useState({
    total_quantity: 0,
    total_sum_in_hand: 0,
  });

  const [soldOverall, setSoldOverall] = useState({
    total_orders: 0,
    total_orders_value: 0,
  });

  useEffect(() => {
    let totalSoldPrice = 0;
    let soldQuantity = 0;
    products.forEach((product) => {
      let soldData = product?.sold_details?.filter(
        (el) =>
          el.status === "done" ||
          el.status === "pending" ||
          el.status === "dispatched"
      );
      soldData?.forEach((el) => {
        totalSoldPrice += el.price;
      });
      soldQuantity += soldData?.length;
    });

    let productQuantity = 0;
    let productValue = 0;
    products.forEach((product) => {
      productQuantity += product.quantity;
      productValue += product.total_in_hand;
    });

    setOverallTotal({
      total_quantity: productQuantity,
      total_sum_in_hand: productValue,
    });

    setSoldOverall({
      total_orders: soldQuantity,
      total_orders_value: totalSoldPrice,
    });
  }, [products]);

  const getProductsfn = () => {
    setIsLoading(true);
    setSoldDataSearchById("");
    axios
      .get(
        `${process.env.REACT_APP_SERVER_DOMAIN}/products?search_term=${searchTerm}&product_search=${productSearch}`
      )
      .then((res) => {
        setProducts(res.data.data);
        setIsLoading(false);
      })
      .catch((err) => {
        setAlert({
          isOpen: true,
          message: "Something Went Wrong",
          type: "danger",
        });
        setIsLoading(false);
      });
    setTimeout(() => {
      setAlert({ ...alert, isOpen: false });
    }, 5000);
  };

  useEffect(() => {
    getProductsfn();
    // eslint-disable-next-line
  }, [searchTerm, productSearch]);

  const handleTypeClick = (type) => {
    setSearchTerm(type);
    setListActive(false);
  };

  const handleProductDelete = (id) => {
    setIsLoading(true);
    try {
      axios
        .delete(`${process.env.REACT_APP_SERVER_DOMAIN}/products/${id}`)
        .then((res) => {
          product_context.setAlert({
            isOpen: true,
            message: "Product deleted",
            type: "danger",
          });
          getProductsfn();
        })
        .catch((err) => {
          product_context.setAlert({
            isOpen: true,
            message: "Something Went Wrong.",
            type: "danger",
          });
          setIsLoading(false);
        });
    } catch (error) {
      product_context.setAlert({
        isOpen: true,
        message: "Server Error",
        type: "danger",
      });
      setIsLoading(false);
    }
    setTimeout(() => {
      product_context.setAlert({ ...product_context.alert, isOpen: false });
    }, 5000);
    setConfirmDialogue({ ...confirmDialogue, isOpen: false });
  };

  const handleShowImage = (product) => {
    setShowImage({
      isOpen: true,
      product: product,
    });
  };

  return (
    <>
      <div>
        <ShowImage showImage={showImage} setShowImage={setShowImage} />
        <div className="d-flex flex-wrap align-items-center justify-content-around m-3">
          <h3 className="text-center">Stock Table</h3>
          <form
            onSubmit={(e) => {
              e.preventDefault();
              setProductSearch(e.target.search.value);
            }}
            className="d-flex my-3 position-relative"
          >
            <input
              value={input}
              className="form-control search"
              type="search"
              name="search"
              placeholder="Search"
              aria-label="Search"
              onChange={(e) => {
                setInput(e.target.value);
              }}
            />
            {productSearch ? (
              <CloseIcon
                onClick={() => {
                  setProductSearch("");
                  setInput("");
                }}
                className="fa-solid fa-xmark searchCLose"
              ></CloseIcon>
            ) : null}

            <button type="submit" className="btn btn-secondary mx-2">
              Search
            </button>
          </form>
          <Link to="/addstock">
            <button className="btn btn-secondary">Add</button>
          </Link>
        </div>
        <hr />
        <Edit
          sizeInp={sizeInp}
          setSizeInp={setSizeInp}
          editParams={editParams}
          setEditParams={setEditParams}
        />

        <div className="types">
          <div className="fit-content">
            <ul className={`my-2 ${listActive ? "active-t" : ""} `}>
              {product_context.productType?.map((type, i) => {
                return (
                  <li
                    className={`mx-3  ${searchTerm === type ? "active " : ""}`}
                    onClick={() => handleTypeClick(type)}
                    key={i}
                  >
                    {type}
                  </li>
                );
              })}
              <p className="close-icon">
                <CloseIcon
                  className="fa-solid fa-xmark"
                  onClick={() => {
                    setListActive(false);
                  }}
                ></CloseIcon>
              </p>
            </ul>
            <div className="dropdown mobile-active">
              <button
                type="button"
                className="btn btn-secondary"
                onClick={() => {
                  setListActive(!listActive);
                }}
              >
                {`${searchTerm}`} &#62;
              </button>
              {/* <p>
                <i
                  className={`fa-solid fa-caret-left icon-left ${
                    listActive ? "active-t" : ""
                  }`}
                ></i>
              </p> */}
            </div>
          </div>
        </div>
        <hr className="mb-5" />

        <div className="d-flex align-items-center justify-content-center">
          <div className="stock-table">
            <table className="table-bordered">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Product Name</th>
                  <RoleComponent role="admin">
                    <th className="phone">Options</th>
                  </RoleComponent>
                  <th>Color</th>
                  <th>Size</th>
                  <th>Quatity</th>
                  <RoleComponent role="admin">
                    <th>Price</th>
                    <th>Additional Price</th>
                    <th>Total In Hand</th>
                    <th>Total Orders</th>
                    <th>Total Orders Price</th>
                  </RoleComponent>
                  <th>Sold Data</th>
                  <RoleComponent role="admin">
                    <th className="desktop">Options</th>
                  </RoleComponent>
                  <th>Seller Name</th>
                </tr>
              </thead>
              <tbody>
                {products?.map((product, i) => {
                  let sizes = product.size;
                  let size = "";
                  sizes.forEach((element) => {
                    size += `${element.toUpperCase()},`;
                  });
                  size = size.slice(0, -1);
                  let soldData = product.sold_details?.filter(
                    (el) =>
                      el.status === "done" ||
                      el.status === "pending" ||
                      el.status === "dispatched"
                  );
                  let totalSoldPrice = 0;
                  soldData?.forEach((el) => {
                    totalSoldPrice += el.price;
                  });
                  return (
                    <tr
                      key={i}
                      className={`${
                        product.quantity === 0 ? "bcg-secondary text-white" : ""
                      }`}
                    >
                      <td>{i + 1}</td>
                      <td
                        className="showImage"
                        onClick={() => {
                          handleShowImage(product);
                        }}
                      >
                        {product.item_name}
                      </td>
                      <RoleComponent role="admin">
                        <td className="action phone">
                          <EditIcon
                            className="fa-solid fa-file-pen mx-3 edit"
                            onClick={() => {
                              document.body.classList.add("remove-scroll");
                              setSizeInp([...product.size]);
                              setEditParams({
                                isOpen: true,
                                data: product,
                                reload: () => {
                                  getProductsfn();
                                },
                              });
                            }}
                          ></EditIcon>
                          <DeleteIcon
                            className="fa-solid fa-trash delete mx-3"
                            onClick={() => {
                              document.body.classList.add("remove-scroll");
                              setConfirmDialogue({
                                isOpen: true,
                                message:
                                  "This item will be deleted permanently.",
                                submitHandle: () => {
                                  handleProductDelete(product._id);
                                },
                              });
                            }}
                          ></DeleteIcon>
                        </td>
                      </RoleComponent>
                      <td>{product.color}</td>
                      <td>{size ? size : "-"}</td>
                      <td>{product.quantity}</td>
                      <RoleComponent role="admin">
                        <td>{product.price}</td>
                        <td>{product.additional_price}</td>
                        <td>{product.total_in_hand}</td>
                        <td>{soldData?.length || "-"}</td>
                        <td>{totalSoldPrice || "-"}</td>
                      </RoleComponent>
                      <td className="sold_data">
                        {soldData.length !== 0 ? (
                          <select
                            onChange={(e) => {
                              setSoldDataSearchById(e.target.value);
                              navigate("/orderstable");
                              setOrderTableCategory("ordertable");
                            }}
                            aria-label="Default select example"
                            name=""
                            id=""
                            className="form-select form-select-sm"
                          >
                            <option value="">Sold Data</option>
                            {soldData?.map((sold_data, i) => {
                              let to_show = `${sold_data.purchase_type}-${
                                sold_data.size
                              }-${sold_data.customer_details?.name || ""}-${
                                sold_data.order_date.split("T")[0]
                              }`;
                              return (
                                <option
                                  key={i}
                                  value={sold_data._id}
                                >{`${to_show}`}</option>
                              );
                            })}
                          </select>
                        ) : (
                          "-"
                        )}
                      </td>
                      <RoleComponent role="admin">
                        <td className="action desktop">
                          <EditIcon
                            className="fa-solid fa-file-pen mx-3 edit"
                            onClick={() => {
                              document.body.classList.add("remove-scroll");
                              setSizeInp([...product.size]);
                              setEditParams({
                                isOpen: true,
                                data: product,
                                reload: () => {
                                  getProductsfn();
                                },
                              });
                            }}
                          ></EditIcon>
                          <DeleteIcon
                            className="fa-solid fa-trash delete mx-3"
                            onClick={() => {
                              document.body.classList.add("remove-scroll");
                              setConfirmDialogue({
                                isOpen: true,
                                message:
                                  "This item will be deleted permanently.",
                                submitHandle: () => {
                                  handleProductDelete(product._id);
                                },
                              });
                            }}
                          ></DeleteIcon>
                        </td>
                      </RoleComponent>
                      <td>{product.seller_name}</td>
                    </tr>
                  );
                })}
                <RoleComponent role="admin">
                  <tr className="bcg-danger">
                    <td colSpan={6}>
                      Total Quantity: {overallTotal.total_quantity}
                    </td>
                    <td colSpan={3}>
                      Overall Total: {overallTotal.total_sum_in_hand}
                    </td>
                    <td colSpan={2}>
                      Total Orders: {soldOverall.total_orders}
                    </td>
                    <td colSpan={2}>
                      Total Orders-Value: {soldOverall.total_orders_value}
                    </td>
                  </tr>
                </RoleComponent>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
}

export default StockTable;
